<template>
  <div style="background-color: #fafafa;padding: 20px">
    <div style="font-size: 20px">
      <el-breadcrumb separator="/" style="margin-left: 10px; margin-top: 5px">
        <el-breadcrumb-item :to="{ path: '/console' }" >数据中心</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/ProcessApproval' }">流程审核</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div style="margin-top: 20px;display: flex;width: 100%">
      <div>
        <el-button-group>
          <el-button :disabled="initLoading || editLoading || status === 0" :type="status === 0 ? 'primary':''" plain @click="checkStatus(0)">待审核</el-button>
          <el-button :disabled="initLoading || editLoading || status === 1" :type="status === 1 ? 'primary':''" plain @click="checkStatus(1)">已完成</el-button>
        </el-button-group>
      </div>
      <div style="margin-left: 20px">
        <span>关键词：</span><el-input placeholder="流程id/业务员信息/导购信息/省/市/区/门店名/连锁" style="width: 320px" v-model="params[status].keywords" clearable></el-input>
      </div>
      <div style="margin-left: 20px">
        <span>{{ status === 0 ? '送达' : '完成' }}时间：</span>
        <el-date-picker
          v-model="params[status].timeRng"
          type="datetimerange"
          value-format="yyyy-MM-dd HH:mm:ss"
          range-separator="至"
          :default-time="['00:00:00','23:59:59']"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </div>
      <div style="margin-left: 20px">
        <el-button type="primary" @click="init(params[status].pageNum,params[status].pageSize)" :loading="initLoading">查询</el-button>
      </div>
      <div style="margin-left: 20px">
        <el-button type="primary" @click="downloadExcel" :disabled="tableData[status].length === 0" :loading="initLoading">导出</el-button>
      </div>
      <div style="margin-left: auto" v-if="status === 0">
        <el-button type="primary" :loading="initLoading" :disabled="checked" @click="submit()">提交</el-button>
      </div>
    </div>
    <div v-loading="initLoading" style="margin-top: 10px">
      <div style="margin-bottom: 10px;float: right">
        <el-checkbox-group v-model="review" @change="(val) => checkedClickAll(val)" v-if="status === 0">
          <el-checkbox label="1">全部通过</el-checkbox>
          <el-checkbox label="2">全部退回</el-checkbox>
        </el-checkbox-group>
        <div v-else style="width: 100px;height: 19px"></div>
      </div>
      <el-table
        :data="tableData[status]"
        :span-method="arraySpanMethod"
        :cell-style="getCellStyle"
        max-height="600"
        style="padding-left: 30px">
        <el-table-column
          label="小票"
          align="center"
          width="150">
          <template slot-scope="scope">
            <el-image
              style="width: 80px; height: 80px"
              :src="scope.row.imgUrl + '?x-oss-process=image/resize,m_pad,w_100,h_100'"
              :preview-src-list="[scope.row.imgUrl]">
            </el-image>
          </template>
        </el-table-column>
        <el-table-column
          label="流程编号"
          prop="pid"
          align="center"
          width="150">
          <template slot-scope="scope">
            <el-popover
              placement="right"
              title="审批流程"
              width="500"
              trigger="hover">
              <el-table :data=" scope.row.approvalList">
                <el-table-column width="150" property="name" label="审批人"></el-table-column>
                <el-table-column width="100" label="时间">
                  <template slot-scope="scope2">
                    {{scope2.row.status === '审核中' ? scope2.row.created: scope2.row.updated}}
                  </template>
                </el-table-column>
                <el-table-column width="100" property="status" label="状态"></el-table-column>
                <el-table-column width="150" property="remark" label="备注"></el-table-column>
              </el-table>
              <div style="color: #4ca2ea" slot="reference">
                <span>{{ scope.row.pid }}</span><i class="el-icon-info"></i>
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          label="申报人"
          prop="saleInfo"
          align="center"
          width="150">
        </el-table-column>
        <el-table-column
          label="申报产品"
          align="center">
          <template slot-scope="scope">
            <el-popover
              v-if="scope.row.stockStartTime && scope.row.stockStartTime !== '无'"
              placement="top"
              :title="'进销存数据来源  ' + scope.row.propValue"
              width="320"
              trigger="hover">
              <div style="white-space: pre-line">{{scope.row.stockStartTime}}</div>
              <mini-table slot="reference" :data="scope.row.productList" :html-show="status === 0" :show-header="false" @edit-open="editOpen(scope.$index,scope.row)" :columns="productColumns"/>
            </el-popover>
            <mini-table v-else :data="scope.row.productList" :html-show="status === 0" :show-header="false" @edit-open="editOpen(scope.$index,scope.row)" :columns="productColumns"/>
          </template>
        </el-table-column>
        <el-table-column
          label="申报销量"
          align="center"
          width="100">
        </el-table-column>
        <el-table-column
          label="总进货量"
          align="center"
          width="100">
        </el-table-column>
        <el-table-column
          label="总销售数"
          align="center"
          width="100">
        </el-table-column>
        <el-table-column
          label="近3月进货量"
          align="center"
          width="100">
        </el-table-column>
        <el-table-column
          v-if="status === 0"
          label="预警类型"
          align="center"
          prop="warningType"
          width="100">
        </el-table-column>
        <el-table-column
          v-if="status === 0"
          label="送达时间"
          align="center"
          prop="deliveryTime"
          width="100">
        </el-table-column>
        <el-table-column
          v-if="status === 1"
          label="完成时间"
          align="center"
          prop="completedTime"
          width="100">
        </el-table-column>
        <el-table-column
          v-if="status === 1"
          label="流程状态"
          align="center"
          width="100">
          <template slot-scope="scope">
            {{statusFormat(scope.row)}}
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          width="150">
          <template slot-scope="scope">
            <el-checkbox-group v-model="scope.row.review" @change="(val) => checkedClick(val, scope.$index)" v-if="status === 0">
              <el-checkbox label="1" style="margin-bottom: 10px;margin-left: 25px">核查通过</el-checkbox>
              <el-checkbox label="2">退回小票</el-checkbox>
            </el-checkbox-group>
            <el-button type="primary" plain @click="retrial(scope.row,scope.$index)" v-if="status === 1 && scope.row.settleStatus != '1' && scope.row.status != '4' && scope.row.status != '5'" size="mini">取回重审</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="display: flex;justify-content: center;margin-top: 20px">
        <el-pagination
          @current-change="(page) => init(page,params[status].pageSize)"
          @size-change="(size) => init(1,size)"
          :current-page="params[status].pageNum"
          :page-size="params[status].pageSize"
          layout="total, sizes, prev, pager, next"
          :page-sizes="[20, 50 , 100, 300, 500]"
          :total="params[status].total">
        </el-pagination>
      </div>
    </div>
    <el-dialog title="调整产品" :visible.sync="editCount.open" width="900px" class="productDialog">
      <div>
        <div>流程编号：{{editCount.process.pid}}</div>
        <div style="margin-top: 5px">申报人：{{editCount.process.saleInfo}}</div>
        <div style="margin-top: 5px">预警类型：{{editCount.process.warningType}}</div>
      </div>
      <el-table :data="editCount.process.productList" style="margin-top: 10px" v-loading="editLoading">
        <el-table-column property="name" label="产品" align="center">
          <template slot-scope="scope">
            <span :style="(scope.row.count === 0 ? 'text-decoration: line-through;':'') + scope.row.nameStyle">{{scope.row.name}}</span>
          </template>
        </el-table-column>
        <el-table-column property="historyCount" align="center" label="总进货量" width="100"></el-table-column>
        <el-table-column property="salesCount" align="center" label="总销售数" width="100"></el-table-column>
        <el-table-column property="threeMonthsSalesCount" align="center" label="近3月进货量" width="100"></el-table-column>
        <el-table-column align="center" label="申报数量" width="150">
          <template slot-scope="scope">
            <el-input-number v-model="scope.row.count" controls-position="right" :min="0" :max="9999" size="small"></el-input-number>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 30px;display: flex;justify-content: center">
        <el-button plain @click="() => editCount = {open: false,process:{}}" :loading="editLoading">取消</el-button>
        <el-button type="primary" :loading="editLoading" @click="editProduct" style="margin-left: 50px">完成并通过审核</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import {download, editProduct, init, retrial, submit} from "@/api/ProcessApproval";
import miniTable from "@/components/miniTable/miniTable";
import ImageViewer from "element-ui/packages/image/src/image-viewer.vue"

export default {
  components: {miniTable,ImageViewer},
  data () {
    return {
      initLoading: true,
      editLoading: false,
      token: '',
      params: {0:{pageNum: 1,pageSize: 20, total: 0, keywords: '', timeRng: []},1:{pageNum: 1,pageSize: 20, total: 0, keywords: '', timeRng: []}},
      review: [],
      tableData: {0:[],1:[]},
      editCount: {
        open: false,
        process: {}
      },
      supplierId: null,
      status: 0,//0: 未审核 1：审核通过
      productColumns: [{prop:'name',align:'center'},{prop:'count',align:'center',width:'100',html:'<i class="el-icon-edit-outline" style="color: #4ca2ea;cursor: pointer;"></i>',clickFun:'edit-open'},
        {prop:'historyCount',align:'center',width:'110'},{prop:'salesCount',align:'center',width:'90'},{prop:'threeMonthsSalesCount',align:'center',width:'90'}]
    }
  },
  created() {
    const supplierId = localStorage.getItem('supplierId');
    this.supplierId = supplierId ? supplierId : ''
    this.token = localStorage.getItem('token')
    this.init(1,this.params[this.status].pageSize)
  },
  computed: {
    checked() {
      return !this.tableData[this.status].some(item => item.review.length > 0)
    }
  },
  methods: {
    init(pageNum,pageSize) {
      this.review = []
      this.params[this.status].pageNum = pageNum ? pageNum : this.params[this.status].pageNum
      this.params[this.status].pageSize = pageSize ? pageSize : this.params[this.status].pageSize
      this.params[this.status].status = this.status
      this.initLoading = true
      let timeRng = this.params[this.status].timeRng
      if (timeRng && timeRng.length === 2 && timeRng[0] && timeRng[1]) {
        this.params[this.status].startTime = timeRng[0]
        this.params[this.status].endTime = timeRng[1]
      } else  {
        this.params[this.status].startTime = ''
        this.params[this.status].endTime = ''
      }
      init(this.token,this.params[this.status]).then(({data}) => {
        this.tableData[this.status] = data.data.list
        this.tableData[this.status].forEach(item => item.review = [])
        this.params[this.status].total = data.data.total
      }).finally(() => this.initLoading = false)
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 3) {
        return [1, 5]
      } else if (columnIndex > 3 && columnIndex <= 7) {
        return [0, 0]
      }
    },
    getCellStyle({row, column, rowIndex, columnIndex}) {
      if (columnIndex === 3) {
        return {padding: 0}
      }
    },
    checkedClick(value,index) {
      if (value.length > 0) {
        value = value.slice(-1)
      }
      this.tableData[this.status][index].review = value
      let b = this.tableData[this.status].every(item => item.review.includes(value[0]));
      if (b) {
        this.review = value
      } else {
        this.review = []
      }
    },
    checkedClickAll(value) {
      if (value.length === 0) {
        this.review = [];
      } else {
        this.review = value.slice(-1);
      }
      this.tableData[this.status].forEach(item => item.review = this.review)
    },
    submit() {
      this.$confirm('确认提交审核结果?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.initLoading = true
        let data = this.tableData[this.status].filter(item => item.review && item.review.length > 0).map(item => {
           return  {
             pid: item.pid,
             review: item.review[0],
             warningType: item.warningType
           }
        })
        submit(this.token,data).then(({data}) => {
          this.$notify({
            title: '成功',
            message: data.data,
            position: 'bottom-right',
            type: 'success'
          });
        }).finally(() => this.init(1,this.params[this.status].pageSize))
      })
    },
    downloadExcel() {
      let timeRng = this.params[this.status].timeRng
      this.params[this.status].status = this.status
      if (timeRng && timeRng.length === 2 && timeRng[0] && timeRng[1]) {
        this.params[this.status].startTime = timeRng[0]
        this.params[this.status].endTime = timeRng[1]
      } else  {
        this.params[this.status].startTime = ''
        this.params[this.status].endTime = ''
      }
      if (this.status === 1 && !this.params[1].keywords && (!this.params[1].startTime || !this.params[1].endTime)) {
        this.$notify({
          type: 'warning',
          message: '请填写关键词或者选择完成时间',
          title: '提示',
          position: 'bottom-right'
        })
        return
      }
      this.initLoading = true
      download(this.token,this.params[this.status]).then(res => {
        if (res !== null) {
          this.handleDownload(res)
          this.$notify({
            type: 'success',
            message: '导出成功',
            title: '成功',
            position: 'bottom-right'
          })
        }
      }).finally(() => this.initLoading = false)
    },
    handleDownload(res) {
      let blob = new Blob([res.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      const fileName = decodeURI(res.headers['filename'])
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
    },
    editOpen(index,process) {
      this.editCount = {
        open: true,
        index: index,
        process: JSON.parse(JSON.stringify(process))
      }
      this.editCount.process.productList = this.editCount.process.productList.map(it => {
        it.originCount = it.count
        return it
      })
    },
    editProduct() {
      let productList = this.editCount.process.productList.filter(it => it.count > 0)
      if (productList.length === 0) {
        this.$notify({
          type: 'warning',
          message: '提交的产品申报数量不能全部为0',
          title: '提示',
          position: 'bottom-right'
        })
        return
      }
      const params = {
        pid : this.editCount.process.pid,
        productList: this.editCount.process.productList
      }
      this.editLoading = true
      editProduct(this.token,params).then(({data}) => {
        if (data.data === 1) {
          this.$notify({
            type: 'success',
            message: '调整产品成功',
            title: '成功',
            position: 'bottom-right'
          })
          this.tableData[this.status].splice(this.editCount.index, 1);
          this.editCount = {
            open: false,
            index: -1,
            process: {}
          }
        } else {
          this.$notify({
            type: 'error',
            message: '调整产品失败',
            title: '成功',
            position: 'bottom-right'
          })
        }
      }).finally(() => this.editLoading = false)
    },
    checkStatus(status) {
      this.status = status
      if (this.tableData[this.status].length === 0) {
        this.init(1, this.params[this.status].pageSize)
      }
    },
    statusFormat(row) {
      const status = row.status
      const settleStatus = row.settleStatus
      if (settleStatus == '1') return '已发放'
      if (status == '4' || status == '5') return '导购已取消'
      if (status == '3') {
        const {position} = row.approvalList[row.approvalList.length - 1]
        return position + '已退回'
      }
      return '待发放'
    },
    //取回重审
    retrial(row,index) {
      this.$confirm('您确定要取回重审吗？这将清空当前数据并恢复到区域管理员审核状态。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.initLoading = true
        retrial(this.token,row.pid).then(({data}) => {
          if (data.data === 'ok') {
            this.$notify({
              type: 'success',
              message: '取回重审成功',
              title: '成功',
              position: 'bottom-right'
            })
            this.tableData[this.status].splice(index, 1);
          } else {
            this.$notify({
              type: 'error',
              message: data.data,
              title: '失败',
              position: 'bottom-right'
            })
          }
        }).finally(() => this.initLoading = false)
      })
    }
  }
}
</script>

<style scoped>
.productDialog >>> .el-dialog__body {
  padding-top: 0 !important;
}
</style>
